// TermsScreen.jsx -- onboarding step `terms` (canvas 3). Single job: show the short version, link the
// full documents, and record one affirmative "I agree" (clickwrap). The gate keys it by versions.
import { useState } from 'react';
import { shell, headline, eyebrow, primaryBtn, disabledBtn, spacer, StepBar, C } from './onboardingStyles';

const POINTS = [
  'SlipTrack tracks bets you place with your sportsbook. We never take wagers or hold money.',
  'For adults 21 and older in the US.',
  'We store your slips and bet history so we can track them. Delete everything any time from Account.',
  'Nothing in SlipTrack is betting advice.',
  'We record masked screen sessions to fix bugs and improve the app.',
];
const row = { display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', height: 52, background: 'none', border: 'none', borderBottom: `1px solid ${C.border}`, color: C.primary, font: 'inherit', fontSize: 15, fontWeight: 600, cursor: 'pointer', padding: 0 };

export default function TermsScreen({ onAgree, onOpenLegal }) {
  const [done, setDone] = useState(false);
  return (
    <div style={shell}>
      <StepBar step={2} />
      <div style={{ marginTop: 40, display: 'flex', flexDirection: 'column', gap: 10 }}>
        <div style={eyebrow}>STEP 2 OF 3</div>
        <h1 style={headline}>The short version</h1>
      </div>
      <ul style={{ margin: '24px 0 0', padding: 0, listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 18 }}>
        {POINTS.map((p) => <li key={p} style={{ fontSize: 15, lineHeight: 1.45, color: C.bright }}>{p}</li>)}
      </ul>
      <div style={{ marginTop: 24, borderTop: `1px solid ${C.border}` }}>
        <button type="button" style={row} onClick={() => onOpenLegal('terms.html')}>Read the Terms of Service<span aria-hidden="true" style={{ color: C.tertiary }}>›</span></button>
        <button type="button" style={row} onClick={() => onOpenLegal('privacy.html')}>Read the Privacy Policy<span aria-hidden="true" style={{ color: C.tertiary }}>›</span></button>
      </div>
      <div style={spacer} />
      <div style={{ fontSize: 12, lineHeight: 1.5, color: C.tertiary, textAlign: 'center', marginBottom: 12 }}>By tapping I agree, you accept the Terms of Service and Privacy Policy.</div>
      <button type="button" disabled={done} style={done ? disabledBtn : primaryBtn} onClick={() => { if (done) return; setDone(true); onAgree(); }}>I agree</button>
    </div>
  );
}
